/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { SuggestionStatus } from './SuggestionStatus.js';
import {
    SuggestionStatusFromJSON,
    SuggestionStatusFromJSONTyped,
    SuggestionStatusToJSON,
} from './SuggestionStatus.js';

/**
 * 
 * @export
 * @interface UpdateSuggestionRequest
 */
export interface UpdateSuggestionRequest {
    /**
     * 
     * @type {SuggestionStatus}
     * @memberof UpdateSuggestionRequest
     */
    status?: SuggestionStatus;
}

/**
 * Check if a given object implements the UpdateSuggestionRequest interface.
 */
export function instanceOfUpdateSuggestionRequest(value: object): boolean {
    return true;
}

export function UpdateSuggestionRequestFromJSON(json: any): UpdateSuggestionRequest {
    return UpdateSuggestionRequestFromJSONTyped(json, false);
}

export function UpdateSuggestionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSuggestionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : SuggestionStatusFromJSON(json['status']),
    };
}

export function UpdateSuggestionRequestToJSON(value?: UpdateSuggestionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': SuggestionStatusToJSON(value['status']),
    };
}

